'use strict';

var LOCALE = {
  at: {
    code: 'de_at',
    currency: 'eur',
  },
  ch: {
    code: 'en_ch',
    currency: 'chf',
  },
  de: {
    code: 'de_de',
    currency: 'eur',
  },
};

var iban = {
  eur: 'CH79 8000 5000 0542 3709 7',
  chf: 'CH03 8000 5000 0542 3701 0',
};

module.exports = function($scope, PaymentDA, officeResolve, smsCreditResolve, Billing) {
  var locale = LOCALE[officeResolve.address.countryCode.toLowerCase()].code || 'de-de';
  var currency = LOCALE[officeResolve.address.countryCode.toLowerCase()].currency || 'eur';
  var checkout;
  $scope.chooseLoading = false;
  $scope.isPaypalLoading = false;
  $scope.iban = iban[currency];
  $scope.smsCredit = smsCreditResolve.smsCredit;

  var getSMSCredit = function() {
    Billing.getSMSCredit().then(
      function(billing) {
        $scope.smsCredit = billing.smsCredit;
      },
      function(error) {
        console.log(error);
      },
    );
  };

  $scope.amounts = [
    { amount: 500, label: '5,00 ' + currency.toUpperCase() + ' (=50 SMS)' },
    { amount: 1000, label: '10,00 ' + currency.toUpperCase() + ' (= 100 SMS)' },
    { amount: 1500, label: '15,00 ' + currency.toUpperCase() + ' (= 150 SMS)' },
    { amount: 2000, label: '20,00 ' + currency.toUpperCase() + ' (= 200 SMS)' },
    { amount: 2500, label: '25,00 ' + currency.toUpperCase() + ' (= 250 SMS)' },
    { amount: 3000, label: '30,00 ' + currency.toUpperCase() + ' (= 300 SMS)' },
  ];

  $scope.smspayment = {
    amount: 500,
    type: 'transfer',
  };

  var tearDownPayPal = function() {
    if (checkout) {
      checkout.teardown(function() {
        checkout = null;
      });
    }
  };

  $scope.setPaymentMethod = function(method) {
    $scope.smspayment.type = method;
    $scope.loadPayPal();
  };

  $scope.loadPayPal = function() {
    $scope.isPaypalLoading = false;
    tearDownPayPal();

    switch ($scope.smspayment.type) {
      case 'paypal':
        $scope.isPaypalLoading = true;
        var amount = ($scope.smspayment.amount / 100).toPrecision(3);

        PaymentDA.getClientToken().then(
          function(response) {
            braintree.setup(response.clientToken, 'paypal', {
              container: 'paypal-container',
              singleUse: true,
              amount: amount,
              currency: currency.toUpperCase(),
              displayName: 'Termin2go',
              locale: locale,
              enableShippingAddress: 'false',
              onPaymentMethodReceived: function(response) {
                PaymentDA.transactionSale({
                  officeId: officeResolve._id,
                  amount: amount,
                  nonce: response.nonce,
                }).then(function() {
                  getSMSCredit();
                });
                $scope.isPaypalLoading = false;
              },
              onCancelled: function() {
                $scope.isPaypalLoading = false;
              },
              onReady: function(integration) {
                checkout = integration;
              },
            });
            $scope.isPaypalLoading = false;
          },
          function() {
            $scope.isPaypalLoading = false;
          },
        );

        break;
      default:
    }
  };
};



// WEBPACK FOOTER //
// ./src/app/modules/sms/SMSCreditCtrl.js